import { ActionStore, ToastStore } from '@stores/models/store';
import * as Reducers from '@stores/reducers/Reducers';

const initialState: ToastStore[] = [];

const reducer = (
  state = initialState,
  action: ActionStore<ToastStore>,
): ToastStore[] => {
  switch (action.type) {
    case Reducers.ADD_TOAST:
      return [
        ...state,
        {
          id: new Date().toISOString(),
          title: action.payload.title || '',
          message: action.payload.message || '',
          level: action.payload.level || 'info',
          showCloseButton: action.payload.showCloseButton,
          persist: action.payload.persist,
        },
      ];
    case Reducers.REMOVE_TOAST:
      return state.filter(
        (toast: ToastStore) => toast.id !== action.payload.id,
      );
    default:
      return state;
  }
};

export default reducer;
